<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7281 2.46977C12.5533 2.54049 14.289 3.2803 15.6038 4.54836L14.9095 5.26841C13.7716 4.17081 12.2694 3.53036 10.6896 3.46915C9.10977 3.40796 7.5628 3.93024 6.34336 4.93647C5.12388 5.94274 4.31696 7.36242 4.07714 8.92515C3.83732 10.4878 4.18131 12.0841 5.04286 13.4097L4.20422 13.955C3.20878 12.4235 2.81185 10.579 3.08892 8.77352C3.36599 6.96807 4.29786 5.32775 5.70668 4.1652C7.11552 3.00268 8.90295 2.39911 10.7281 2.46977Z"
      fill="black"
    />
    <path
      d="M16.7765 5.99231C17.7215 7.52222 18.0808 9.34284 17.7875 11.1171C17.4943 12.8912 16.5685 14.4991 15.1815 15.6436C13.7944 16.7881 12.0399 17.3921 10.2423 17.3431C8.4447 17.2941 6.72557 16.5957 5.40295 15.3774L6.08043 14.6414C7.22528 15.6961 8.71326 16.3007 10.2692 16.3432C11.8253 16.3857 13.3445 15.8633 14.5452 14.8726C15.7459 13.8819 16.5471 12.4897 16.8009 10.9539C17.0547 9.41814 16.7435 7.84242 15.9254 6.5181L16.7765 5.99231Z"
      fill="black"
    />
    <path
      d="M16.0573 5.12772L11.797 6.08874L11.5767 5.11298L14.7798 4.39017L13.8039 1.25628L14.7585 0.958313L16.0573 5.12772Z"
      fill="black"
    />
    <path
      d="M9.11098 14.5827L5.90773 15.3037L6.88418 18.4396L5.92939 18.7369L4.6311 14.5667L8.89172 13.607L9.11098 14.5827Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: "IconQrReload",
};
</script>
